import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=547924a3&scoped=true"
import script from "./ui-select.vue?vue&type=script&lang=js"
export * from "./ui-select.vue?vue&type=script&lang=js"
import style0 from "./ui-select.vue?vue&type=style&index=0&id=547924a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547924a3",
  null
  
)

export default component.exports